import { render, staticRenderFns } from "./customSubAsset.vue?vue&type=template&id=8bae089e&scoped=true&"
import script from "./customSubAsset.vue?vue&type=script&lang=js&"
export * from "./customSubAsset.vue?vue&type=script&lang=js&"
import style0 from "./customSubAsset.vue?vue&type=style&index=0&id=8bae089e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bae089e",
  null
  
)

export default component.exports